/**
 * The marker both native WebViews append to their default user agent. The version is whatever the
 * app build carries, so only the product name and the platform are matched here.
 */
const nativeEmbedMarker = /\bMusic24Native\/\S+ \((?:ios|android)\)/;

/** Whether the page is drawn inside one of the native apps' WebViews. */
export function isNativeEmbed(userAgent: string): boolean {
  return nativeEmbedMarker.test(userAgent);
}

/** Whether this page is drawn inside one of the native apps' WebViews. False outside a browser. */
export function isNativeEmbedPage(): boolean {
  return typeof navigator !== 'undefined' && isNativeEmbed(navigator.userAgent);
}
